export default {
  AccountCenter: {
    title: 'Account Center',
    accountInfo: 'Account Information',
    accountManagement: 'Account Management',
    name: 'Name',
    phone: 'Phone Number',
    email: 'Email',
    department: 'Department',
    password: 'Password',
    verified: 'Verified',
    configured: 'Configured',
    changePassword: 'Change Password',
    oldPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    oldPasswordPlaceholder: 'Enter current password',
    newPasswordPlaceholder: 'Enter a new password',
    confirmPasswordPlaceholder: 'Enter the new password again',
    passwordFormatTip: 'Use 8–20 characters: English letters, numbers, and ASCII special characters. Spaces are not allowed.',
    passwordStrengthLabel: 'Password strength: {strength}',
    passwordStrengthLevels: { weak: 'Weak', medium: 'Medium', strong: 'Strong' },
    passwordStrengthAdvice: 'Use a longer password with a mix of uppercase and lowercase letters, numbers, and special characters. Avoid easy-to-guess passwords.',
    passwordStrengthReference: 'Strength is an estimate only',
    confirmChange: 'Confirm Change',
    oldPasswordRequired: 'Enter current password',
    newPasswordRequired: 'Enter new password',
    confirmPasswordRequired: 'Enter the new password again',
    passwordLengthError: 'Password must be 8-20 characters',
    passwordCharacterError: 'Only English letters, numbers, and half-width special characters are supported. Spaces are not allowed.',
    passwordNotMatch: 'The two new passwords do not match',
    passwordUpdateSuccess: 'Password changed successfully',
    defaultPasswordWarningTitle: 'Password Security Reminder',
    defaultPasswordWarningMessage: 'This account is still using the default password. Please change it as soon as possible to protect your account.',
    changePasswordNow: 'Change Now',
  },
};
